import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PageLoader } from "@/components/kit";

export const ProtectedRoute = ({ children, superOnly }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <PageLoader />;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  if (superOnly && user.platform_role !== "super_admin") return <Navigate to="/dashboard" replace />;
  return children;
};
